// extracted by mini-css-extract-plugin
module.exports = {"AddPartCard":"PXNMOPiAwPYsN9GJ5LL9Rg=="};